import React from "react";
import "./vacancy.css";
import Navbar from "../../components/navbar/Navbar";
import logo from "../../images/white-logo.png";
import Rightside from "../../components/rightside/Rightside";
// import List from '../../components/list/List';
import MobFilter from "../../components/Mobfilter/MobFilter";
import Filter from "../../components/filter/Filter";
import { GoLocation } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import parse from 'html-react-parser';
import { useState, useEffect } from "react";
import axios from "axios";
import VacancyShort from "../../components/filter/VacancyShort";
import { baseLocal, baseUrl } from "../../context/BaseUrl";
import MobNav from "../../components/Mobnav/MobNav";
import MobFilterV from "../../components/Mobfilter/MobFilterV";

const Vacancy = () => {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [category, setCategory] = useState("");
  const [Data, setData] = useState(null);

  async function fetchData() {
    try {
      const response = await axios.get(
        `${baseLocal}/user/vacancy/allvacancies?key=${search}&sort=${sort}${
          category && "&category=" + category
        }&limit=8`
      );
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [search, sort, category]);

  return (
    Data !== null && (
      <>
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>
        <MobNav />
        <div className="vacancy-page container-fluid pt-0 pt-md-5">
          <div className="row">
            <div className="col-md-8 col-sm-12 col-xs-12 ps-md-5 pe-md-4 px-1">
              <VacancyShort
                handle={{ search, setSearch }}
                sortHandle={{ sort, setSort }}
                catHandle={{ category, setCategory }}
              />
              
              <div className="left">
                <h4 className="pb-3 pb-md-4 fw-bold">Vacancies </h4>
                <MobFilterV handle={{ search, setSearch }}
                sortHandle={{ sort, setSort }}
                catHandle={{ category, setCategory }} />
                {Data.map((val, key) => {
                  console.log(val);
                  return (
                    <Link
                      className="text-decoration-none text-black"
                      to={`/vacancy-detail/${val._id}`}
                    >
                      <div className="list-item" key={key}>
                        <h5 className="fw-bold text-capitalize">{val.name}</h5>
                        <p className="location mb-0">{val.location}</p>
                        <p className="text-truncate vacancy-about">
                          {parse(val.about)}
                        </p>
                        <div className="d-flex justify-content-between">
                          <p className="location mb-0">
                            <GoLocation /> {val.location}
                          </p>
                          <div className="buttons d-none d-md-block">
                            <button className="more w-100">
                              <Link to={`/vacancy-detail/${val._id}`}>
                                Know More
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>

            <div className=" col-md-4 col-sm-12 col-xs-12 px-1">
              <div className="rigthside p-0 p-sm-4">
                <Rightside />
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <FooterMob />
      </>
    )
  );
};

export default Vacancy;
